import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59cd24c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-preview-edit-name-popover" }

import { TirPmPopover, PopoverPositionEnum } from "tir-pm-popover";
import { TirPmInput } from "tir-pm-input";
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
} from "tir-pm-button";
import { ref, onMounted, watch, computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'file-preview-edit-name-popover',
  props: {
  /**Поповер открыт */
  isOpened: {
    type: Boolean,
    default: false,
  },
  /**Имя файла */
  fileName: {
    type: String,
    default: "",
  },
  /**Загрузка */
  isLoading: {
    type: Boolean,
    default: false,
  },
},
  emits: ["saveFileName", "update:isOpened"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;





/**Ссылка на компонент поповера */
const $popover = ref<InstanceType<typeof TirPmPopover>>();

const inputValue = ref("");

const isDisabledSave = computed(() => !inputValue.value?.trim());

const removeFileExtension = (fileName: string): string => {
  const lastDotIndex = fileName.lastIndexOf(".");
  if (lastDotIndex === -1) return fileName; // Если точки нет, возвращаем исходное имя
  return fileName.substring(0, lastDotIndex);
};

const save = () => {
  if (isDisabledSave.value) return;
  emit("saveFileName", inputValue.value);
};

const onOpen = () => {
  inputValue.value = removeFileExtension(props.fileName);
  emit("update:isOpened", true);
};

const close = () => $popover.value?.close();

const open = () => $popover.value?.open();

watch(
  () => props.fileName,
  () => {
    inputValue.value = removeFileExtension(props.fileName);
  }
);

watch(
  () => props.isLoading,
  () => {
    if (!props.isLoading) $popover.value?.close();
  }
);

onMounted(() => {
  inputValue.value = removeFileExtension(props.fileName);
});

__expose({
  close,
  open,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmPopover), {
    ref_key: "$popover",
    ref: $popover,
    position: _unref(PopoverPositionEnum).Top,
    onOpen: onOpen,
    onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('update:isOpened', false)))
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(TirPmInput), {
          modelValue: inputValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
          label: "Название файла",
          "is-with-hint": false,
          "auto-focus": "",
          onEnter: save
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", {
          class: "file-preview-edit-name-popover__buttons",
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createVNode(_unref(TirPmButton), {
            variant: _unref(TirPmButtonVariantEnum).PrimaryState,
            size: _unref(TirPmButtonSizeEnum).Small,
            "is-disabled": isDisabledSave.value,
            "is-loading": __props.isLoading,
            onClick: save
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Сохранить ")
            ]),
            _: 1
          }, 8, ["variant", "size", "is-disabled", "is-loading"]),
          _createVNode(_unref(TirPmButton), {
            variant: _unref(TirPmButtonVariantEnum).SecondaryState,
            size: _unref(TirPmButtonSizeEnum).Small,
            onClick: close
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Отмена ")
            ]),
            _: 1
          }, 8, ["variant", "size"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["position"]))
}
}

})